import './styles.sass'

import React, { FC, useEffect, useState } from 'react'
import Checkbox from '../UI/checkbox/ChCheckbox'
import openIcon from '../../assets/icons/open.svg'

interface IFilter {
  title: string,
  list: IListItem[],
  className?: string,
  disabled?: boolean,
  onSelect: (value: any) => void
}

interface IListItem {
  label: string
  default?: boolean,
  value: string
}

const Filter: FC<IFilter> = ({ title, list, className, disabled = false, onSelect }) => {
  const [isFullList, setIsFullList] = useState(false)
  const [checkedValues, setCheckedValues] = useState<string[]>(getDefaultValue())
  const editedList = list.slice(0, 5)
  const hiddenList = list.slice(6)

  const classNames = () => {
    const general = className || ''
    const ifDisabled = disabled || ''
    return `${general} ${ifDisabled}`
  }

  function getDefaultValue() {
    const defaultValue = list.find(item => item.default === true)
    if (defaultValue !== undefined) return [defaultValue.value]
    return []
  }

  function getList() {
    if (list.length > 6) return editedList
    if (list.length <= 6) return list
  }

  function handleSelect(value: any, state: boolean) {
    if (state) {
      setCheckedValues([...checkedValues, value])
      onSelect([...checkedValues, value])
    } else if (!state) {
      setCheckedValues(checkedValues.filter(item => value !== item))
      onSelect(checkedValues.filter(item => value !== item))
    }
  }


  return (
    <div className={`filter-box ${classNames()}`}>
      <div className="title">{title}</div>
      <div className={`checkbox-group`}>
        <div className="alwaysShownBoxes">
          {getList()?.map(item => (
            <Checkbox
              label={item.label}
              id={`${item.label}-${title}`}
              defaultChecked={item.default}
              key={`${item.label}-${title}`}
              value={item.value}
              name={title}
              onChange={handleSelect}
              disabled={disabled}
            />
          ))}
        </div>
        <div className={`hiddenBoxes ${isFullList ? 'opened' : 'closed'}`}>
          {hiddenList !== undefined && (
            hiddenList.map(item => (
              <Checkbox
                label={item.label}
                id={`${item.label}-${title}`}
                defaultChecked={item.default}
                key={`${item.label}-${title}`}
                value={item.value}
                name={title}
                onChange={handleSelect}
                disabled={disabled}
              />
            ))
          )}
        </div>
        {(editedList.length <= list.length && list.length > 6) && (
          <span className={`icon ${isFullList ? 'close-icon' : 'open-icon'}`} onClick={() => setIsFullList(!isFullList)}>
            <img src={openIcon} alt="open list" />
          </span>
        )}
      </div>
    </div>
  )
}

export default Filter
